import { createGetter } from 'react-redux-getters'
import { getCollection, replaceCollections } from '@fakundo/redux-entities'
import keyBy from 'lodash/keyBy'
import { LIVE_CHATS } from 'constants/entityNames'
import { fetchLiveChats } from 'actions/liveChats'

export const getLiveChats = createGetter({
  stateSelector: state => getCollection(state, LIVE_CHATS),
  asyncFetcher: dispatch => dispatch(fetchLiveChats()),
  stateUpdater: (liveChats, dispatch) => dispatch(replaceCollections({
    [LIVE_CHATS]: keyBy(liveChats, 'uuid')
  })),
})
